import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import FileUpload from "components/FileUpload/FileUploadSanction";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import { Button, FormControlLabel, Grid, Switch } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { removeSpecialCharFileName } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import OtpModal from "./OtpModal/OtpModal";
import { parseAndSetFlag } from "utils/Utils";
import JourneyStepper from "./JourneyStepper";

const MultiEsignBtKitLetter = ({
  setNext,
  loanApplicationId,
  classes,
  featureFlags,
  setEsignDisableBtKit,
  esignDisableBtKit,
  disbursalAmount,
}) => {
  let fileUploadComponent = useRef();
  const [preview, setPreView] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [screenshotCheque, setScreenshotCheque] = useState(null);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [backFlex, setBackFlex] = useState(false);
  const [senctionPreview, setSanctionPreview] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [disableGenerate, setDisableGenerate] = useState(false);
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [generateLetter, setGenerateLetter] = useState(false);
  const [optionUpload, setOptionOnlyUpload] = useState(false);
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const esignIntervalRef = useRef(null);
  const esignTimeoutRef = useRef(null);

  const [stepperQuantity, setStepperQuantity] = useState(1);
  const isBTKitEsignEnabled = parseAndSetFlag(
    featureFlags?.enableBtKitLetterEsign
  );
  const sanctionletterLoaderMessage = featureFlags?.sanctionLetterLoaderMessage;
  useEffect(() => {
    if (screenshotCheque !== null) {
      const localUrl = URL.createObjectURL(screenshotCheque);
      setPreView(localUrl);
    }
  }, [screenshotCheque]);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetBtLetterDetails();
  }, []);

  const startEsignPolling = () => {
    if (esignIntervalRef.current) {
      return;
    }
    getEsignLetter();
    esignIntervalRef.current = setInterval(() => {
      getEsignLetter();
    }, 30000);
     esignTimeoutRef.current = setTimeout(() => {
    stopEsignPolling();
  }, 3 * 60 * 1000);
  };

  const stopEsignPolling = () => {
    if (esignIntervalRef.current) {
      clearInterval(esignIntervalRef.current);
      esignIntervalRef.current = null;
    }
    if (esignTimeoutRef.current) {
      clearTimeout(esignTimeoutRef.current);
      esignTimeoutRef.current = null;
    }
    setCallInProgress(false);
  };

  const getEsignLetter = async (flag) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.GET_MULTI_ESIGN_LETTER + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    if (flag === "stop") {
      setCallInProgress(false);
      if(Number(res?.data?.currentSequence) > 1 || res?.data?.currentSequenceStatus === "COMPLETED"){
        setStepperQuantity(2);
      }
    }
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      if (
        res?.data?.currentSequenceStatus === "COMPLETED" ||
        res?.data?.status?.toLowerCase() === "completed"
      ) {
        stopEsignPolling();
        setStepperQuantity(2);
      }
      if (
        (res?.data?.status === "DONE" || res?.data?.status === "COMPLETED") &&
        res?.data?.fileLink
      ) {
        setEsignDisableBtKit(true);
        setSanctionPreview(res?.data?.fileLink);
        setPreView(res?.data?.fileLink);
      }
    }
  };

  const GetBtLetterDetails = async () => {
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    if (
      res?.data?.esignBtLetter &&
      res?.data?.esignBtLetter?.includes("esign")
    ) {
      setPreView(res?.data?.esignBtLetter);
      setEsignDisableBtKit(true);
      setSanctionPreview(res?.data?.esignBtLetter);
    } else if (res?.data?.btLoanLetterLink) {
      setSanctionPreview(res?.data?.btLoanLetterLink);
    }
          getEsignLetter("stop");
  };

  const GenerateSanctionLetter = async () => {
    setCallInProgress(true);
    setGenerateLetter(true);
    const res = await apiHandler({
      url: endpoint.BT_KIT + loanApplicationId,
      method: "GET",
      responseType: "arraybuffer",
      authToken: authToken,
    });
    setCallInProgress(false);
    setGenerateLetter(false);
    const blob = new Blob([new Uint8Array(res.data)], {
      type: "application/pdf",
    });
    const fileURL = URL.createObjectURL(blob);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      setPreView(fileURL);
    }
  };
  const handleEsignNext = () => {
    if (!esignDisableBtKit) {
      toastUpdate("Error", "Please Esign the Document", true);
    } else {
      setNext();
    }
  };
  const handleUpload = async () => {
    if (imagefile) {
      Updatesanctionletter(imagefile);
    } else {
      if (screenshotCheque) {
        setCallInProgress(true);
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(screenshotCheque.name);
        formData.append("file", screenshotCheque, fileName);
        const path = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        setCallInProgress(false);
        const uploadedPath = path.data;
        Updatesanctionletter(uploadedPath.name);
      } else {
        toastUpdate("Error", "Upload BT Kit Letter Before Submited", true);
      }
    }
  };
  const Updatesanctionletter = async (filename) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        btLoanLetterLink: filename,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      toastUpdate("Error", "Upload BT Kit Letter Before Submited", true);

      return;
    } else if (res?.data?.error_code) {
      toastUpdate("Error", "Upload BT Kit Letter Before Submited", true);

      return;
    } else {
      toastUpdate("Success", "Update sanction Letter successfully", true);
      setBackFlex(true);
      setNext();
    }
  };
  const handleProceedUpload = () => {
    setConfirmationModalHeader1("Preview");
    setConfirmationModalMsg1("Preview uploaded letter");
    setConfirmationModal1(true);
  };
  const handleNegativeUploadResponse = () => {
    setConfirmationModal1(false);
    setConfirmationModalHeader1("");
    setConfirmationModalMsg1("");
  };
  const handlePositiveUploadResponse = async () => {
    handleNegativeUploadResponse();
    handleUpload();
  };

  const handleEsign = async () => {
    setCallInProgress(true);
     const sequence = Number(stepperQuantity);
     const apiPath =
        sequence === 1
          ? endpoint.MULTI_ESIGN_LETTER_BT_CASE
          : endpoint.BT_KIT_LETTER_ESIGN;
    const res = await apiHandler({
      url: apiPath + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      if (res?.data?.status === "OTP_VALIDATION") {
        setTransactionId(res?.data?.transactionId);
        setShowModal(true);
      } else {
        const responseString = res?.data?.res;
        const eSignUrl = responseString?.match(
          /eSignUrl=(https:\/\/[^}]+)\}\}$/
        )?.[1];
        if (eSignUrl) {
          window.open(eSignUrl, "_blank");
          startEsignPolling();
        }
      }
    }
  };

  const handleClose = () => {
    setShowModal(!showModal);
  };

  const resendOtp = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.BT_KIT_LETTER_RESEND_OTP + transactionId,
      method: "PUT",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Otp sent successfully", true);
    }
  };

    const getOtpEsignLetter = async () => {
      setCallInProgress(true);
      //BT_KIT_LETTER_UPDATE
      const res = await apiHandler({
        url: endpoint.BT_KIT_GET_ESIGN_LETTER + loanApplicationId,
        method: "GET",
        authToken: authToken,
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        if (
          (res?.data?.status === "COMPLETED" && res?.data?.fileLink) ||
          res?.data?.status === "PENDING"
        ) {
          setPreView(res?.data?.fileLink);
          setSanctionPreview(res?.data?.fileLink);
          setEsignDisableBtKit(true);
        }
      }
    };

  const Otp = async (code1) => {
    setCallInProgress(true);
    const response = await apiHandler({
      url: endpoint.BT_KIT_VALIDATE_OTP,
      method: "POST",
      authToken: authToken,
      data: {
        txnId: transactionId,
        otp: code1,
      },
    });
    setCallInProgress(false);
    if (response?.data?.error_code) {
      toastUpdate("Error", response?.data?.user_description, true);
    } else {
      getOtpEsignLetter();
      setShowModal(false);
    }
  };

  return (
    // <div>
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="Multi BT Kit" />
      </Grid>

      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
            {!preview ? (
              <>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ textAlign: "center" }}
                >
                  <Button
                    onClick={() => GenerateSanctionLetter()}
                    className={classes.nextButton}
                    disabled={disableGenerate}
                  >
                    Generate
                  </Button>
                  {senctionPreview && (
                    <Button
                      className={classes.nextButton1}
                      onClick={() => setPreView(senctionPreview)}
                    >
                      Preview
                    </Button>
                  )}
                </GridItem>
              </>
            ) : (
              <>
                {!esignDisableBtKit && (
                  <>
                    {isBTKitEsignEnabled ? (
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          lg={10}
                          style={{ textAlign: "end" }}
                        >
                          <JourneyStepper
                            currentStep={stepperQuantity}
                            disbursalAmount={disbursalAmount}
                            maxSequence={2}
                          />
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={2}
                          lg={2}
                          style={{ textAlign: "end" }}
                        >
                          <Button
                            size="small"
                            className={classes.nextButton}
                            onClick={handleEsign}
                          >
                            Esign
                          </Button>
                        </GridItem>
                      </GridItem>
                    ) : (
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ textAlign: "end" }}
                      >
                        <FileUpload
                          // avatar={imagefile ? imagefile : DefaultCheque}
                          supportedMimeType={["application/pdf"]}
                          addButtonProps={{
                            color: brandTheme.buttonColor,
                            round: false,
                          }}
                          changeButtonProps={{
                            color: brandTheme.buttonColor,
                            round: false,
                          }}
                          removeButtonProps={{
                            color: "danger",
                            round: false,
                          }}
                          sendFile={(file) => {
                            setScreenshotCheque(file);
                            setImagefile("");
                          }}
                          ref={fileUploadComponent}
                          classes={classes}
                          BTKit
                          buttonTitle={optionUpload ? "Change" : "Upload"}
                          lettername="bt_kit"
                          optionUpload={optionUpload}
                        />
                      </GridItem>
                    )}
                  </>
                )}
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  {preview !== "" ? (
                    <iframe
                      src={preview ? preview : senctionPreview}
                      width="100%"
                      height="500px"
                    />
                  ) : (
                    <div>Downloading BT KIT Document</div>
                  )}
                </GridItem>
              </>
            )}
          </GridContainer>

          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                textAlign: window.innerWidth < 360 ? "center" : "right",
              }}
            >
              <Button
                // style={{ margin: "5px" }}
                size="small"
                // color="info"
                className={classes.nextButton}
                disabled={callInProgress}
                onClick={(event) =>
                  esignDisableBtKit || (optionUpload && !screenshotCheque)
                    ? handleEsignNext()
                    : handleProceedUpload()
                }
              >
                Next
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {callInProgress && (
        <CircularProgresss
          callInProgress={callInProgress}
          text={generateLetter ? sanctionletterLoaderMessage : "Processing..."}
        />
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {confirmationModal1 && (
        <ConfirmationModal
          confirmationModal={confirmationModal1}
          confirmationModalHeader={confirmationModalHeader1}
          confirmationModalMsg={confirmationModalMsg1}
          handleNegativeButton={handleNegativeUploadResponse}
          handlePositiveButton={handlePositiveUploadResponse}
        />
      )}
      {showModal && (
        <OtpModal
          handleClose={handleClose}
          showModal={showModal}
          Otp={Otp}
          ResendOtp={resendOtp}
        />
      )}
    </Grid>
  );
};

MultiEsignBtKitLetter.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
};

export default MultiEsignBtKitLetter;